import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';


if (environment.production) {
  enableProdMode();

  // Silenciar ruido de depuración en producción; se conservan console.error/warn
  // para poder diagnosticar fallas reales desde la consola del navegador.
  console.log = () => {};
  console.debug = () => {};
  console.info = () => {};
}
platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
